import { http } from '../../config/axios'

export default function postConsultaLoteReprocessar(id: string): Promise<string> {
  return http
    .post(`api/consultalote/reprocessar/${id}`)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro postConsultaLoteReprocessar', error)
      throw Error(error.response.data)
    })
}
